import ScreenRouteNames from "@/constants/screen-route-names";

import { isNotificationsActive } from "./permission";

const NOTIFICATION_TITLE = "New message";
const NOTIFICATION_BODY = "You have received a new message";

const TAG_PREFIX = "zconnect-csr-chat-";

let currentTag = `${TAG_PREFIX}${Date.now()}`;
let activeNotification: Notification | null = null;

const onUserReturned = (): void => {
  if (activeNotification) {
    try {
      activeNotification.close();
    } catch {
      // intentionally ignored
    }
    activeNotification = null;
  }
  currentTag = `${TAG_PREFIX}${Date.now()}`;
};

if (typeof window !== "undefined") {
  window.addEventListener("focus", onUserReturned);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") onUserReturned();
  });
}

export const showChatNotification = (): void => {
  if (!isNotificationsActive()) return;
  if (document.hasFocus()) return;

  try {
    const notification = new Notification(NOTIFICATION_TITLE, {
      body: NOTIFICATION_BODY,
      tag: currentTag,
    });

    activeNotification = notification;

    notification.onclick = () => {
      window.focus();
      const chatPath = `/${ScreenRouteNames.CSR_CHAT.path}`;
      if (!window.location.pathname.includes(ScreenRouteNames.CSR_CHAT.path)) {
        window.location.href = chatPath;
      }
      notification.close();
    };
  } catch (err) {
    console.error("[notifications] failed to display", err);
  }
};
